// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__233Vj","col":"styles_col__1TILO"};